import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueSubtasksRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-subtasks-manage',
	path: '/secure/admin/subtasks/ManageSubTasks.jspa',
};
